import { useContext, useMemo } from "react";
import { ApplicationContext } from "../../../components/ApplicationProvider";
import { SoftwareTagWithUpdateStrategy } from "../types/version_management_types";
import _ from "lodash";

interface UseTagDropDownOptionsParams {
    prependOptions?: { value: number; text: string }[];
}

export function useTagDropDownOptions(
    softwareTags: SoftwareTagWithUpdateStrategy[],
    { prependOptions }: UseTagDropDownOptionsParams = {}
) {
    const { t } = useContext(ApplicationContext);

    return useMemo(() => {
        const DROP_DOWN_LABEL_MAP: Record<string, string> = {
            Release: t("version_management.release_frequencies.monthly"),
            Quarterly: t("version_management.release_frequencies.quarterly"),
            // don't need to use translations for this as it comes from the Database, but just put a space in here.
            QRCandidate: "QR Candidate",
        };

        const tags = _(softwareTags)
            .orderBy(["releaseFrequency", "isDefaultForReleaseFrequency"], ["asc", "desc"])
            .map((tag) => {
                const label = DROP_DOWN_LABEL_MAP[tag.name] ?? tag.name;
                return { text: label, value: tag.id };
            })
            .value();

        return prependOptions ? [...prependOptions, ...tags] : tags;
    }, [softwareTags, prependOptions, t]);
}
